import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import egLogo from '../../assets/images/partnerCentralLogo.svg';

function BrandLogo(props) {
    const { logo, callStatus, isFooter } = props;
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    const css = classnames({
        'ulx-header__image': !isFooter,
        'ulx-footer__logo': isFooter
    });

    if (isClient && callStatus && (!callStatus.success && !callStatus.fail)) {
        return null;
    }

    const logoImage = logo && logo.image && logo.link && logo.altText
        ? <a href={logo.link}><img className={css} src={logo.image} alt={logo.altText} width="178" height="32" /></a>
        : <a href="https://www.expediagroup.com/"><img className={css} src={egLogo} alt="Expedia group logo" width="128" height="54" /></a>;

    // paint logo after componentDidMount
    return isClient ? logoImage : '';
}

BrandLogo.propTypes = {
    logo: PropTypes.shape({
        image: PropTypes.string,
        link: PropTypes.string,
        text: PropTypes.string,
        altText: PropTypes.string
    }).isRequired,
    callStatus: PropTypes.shape({
        start: PropTypes.bool.isRequired,
        success: PropTypes.bool.isRequired,
        fail: PropTypes.bool.isRequired
    }).isRequired,
    isFooter: PropTypes.bool
};

BrandLogo.defaultProps = {
    isFooter: false
};

export default BrandLogo;
